export default "__VITE_ASSET__Bzo2uYZE__"